
  import {defineComponent} from "vue";
  import AuthenticationPromptComponent from "@/components/shared/AuthenticationPromptComponent.vue";
  import CellphoneAuthenticationComponent from "@/components/shared/CellphoneAuthenticationComponent.vue";
  import router from "@/router";
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import {mapMutations, mapState} from "vuex";

  export default defineComponent({
    name: 'non-member-view',
    components: {
      AuthenticationPromptComponent,
      CellphoneAuthenticationComponent,
    },
    data() {
      return {
        showLoginPopup: true,
        showCertificationPopup: false,
      }
    },
    mounted(): void {
      window.vm.parentView = this;
    },
    computed: {
      showDimmed(): boolean {
        return this.showLoginPopup || this.showCertificationPopup;
      },
      ...mapState({
        nextView: (state: any) => state.NextViewStore.nextView,
      }),
    },

    methods: {
      openLoginPopup(): void {
        let searchparams = new URLSearchParams();
        searchparams.append("redirect_uri", process.env.VUE_APP_API_SERVER_URL + process.env.VUE_APP_OAUTH_REDIRECT_PATH);
        searchparams.append("appYn", "N");

        window.open(process.env.VUE_APP_OAUTH_SERVER_URL + searchparams.toString());
      },
      closeAuthenticationPromptPopup(): void {
        this.showLoginPopup = false;
        router.push(new NamedRouting('HomeView'));
      },
      openCellphoneAuthenticationPopup(): void {
        this.showLoginPopup = false;
        this.showCertificationPopup = true;
      },
      closeCellphoneAuthenticationPopup(): void {
        this.showCertificationPopup = false;
        this.showLoginPopup = true;
      },
      saveToken(token: string): void {
        this.setToken(token);
      },
      moveToNextPage(): void {
        router.replace(this.nextView);
      },
      alertLoginFailed(): void {
        alert('일시적인 오류로 로그인이 실패하였습니다. 잠시 후, 다시 시도해주세요.');
      },
      ...mapMutations('MemberStore', [
        'setToken',
      ]),
    },
  })
